import React, {useState, useContext, useEffect} from 'react'
import Pie from './Pie'
import AppContext from '../../../contexts/app-context';
import AuthContext from '../../../contexts/auth-context';
import useAxios from '../../../hooks/useAxios';
import { urls } from '../../config/variables';

const CptIssues = () => {
  const { globalFilterQuery } = useContext(AppContext);
  const { token } = useContext(AuthContext);
  const { operation } = useAxios();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = () => {
    operation(
      {
        method: 'GET',
        url: urls.CPT_ISSUES + (globalFilterQuery || ''),
        headers: { Authorization: `token ${token}` },
      },
      (data) => {
        setData(data);
        setLoading(false);
      },
      (err) => {
        setData([]);
        setLoading(false);
      }
    );
  }

  useEffect(() => {
    if (token) {
      fetchData();
    }
    // eslint-disable-next-line
  }, [globalFilterQuery, token])  

  // reformate data to fit pie chart component data format.
  const formattedData = data
  .filter(item => item.issue_count > 0)
  .map(item => ({
    label: item.issue_name,
    count: item.issue_count,
    cost: Number(item.issue_cost),
  }))
  .sort((a, b) => b.count - a.count);

  // Take top 10 to show in pie chart, the rest will be shown in details dialog.
  const top = formattedData.slice(0, 10);

  return (
    <Pie
      chartId='cpt-issues'
      data={formattedData}
      top={top}
      loading={loading}
      showLegend={false}
      showDetailsDialog={true}
      pieTitle="Procedure Rejections"
      pieSubTitle="Distribution of CPT rejection reasons"
      pieCenterLabel="CPT Issues"
      dialogButtonLabel="More Details"
      dialogTitle="Procedure Issues"
      tableHead={['CPT Issues', 'Count', 'Cost', 'Share']} // Pass tableHead titles to DetailsDialog
    />
  )
}

export default CptIssues